import { configure } from "vue-gtag";
import router from "../router";

export default {
  install: () => {
    configure({
      tagId: "G-TZF1JS5NQ5",
      pageTracker: {
        router
      }
    });
  }
};
